export const PROFILE_GET = '@PROFILE_GET'
export const PROFILE_GET_SUCCESS = '@PROFILE_GET_SUCCESS'
export const PROFILE_GET_FAILURE = '@PROFILE_GET_FAILURE'

export default {
  PROFILE_GET,
  PROFILE_GET_SUCCESS,
  PROFILE_GET_FAILURE
}
